import React from 'react';
import PropTypes from 'prop-types';
import PinInput from 'react-pin-input';
import TextField from '@material-ui/core/TextField';

/*
 *  @description Component
 *  Ajout d'un mask pour les numéro de téléphone
 *  et affichage d'un clavier sur mobile
 */

const PinCodeInput = props => {
  const { error, ...other } = props;
  return (
    <div>
      <PinInput
        {...other}
        focus
        length={6}
        style={{
          padding: '1px',
          display: 'flex',
          justifyContent: 'space-between'
        }}
        inputStyle={{
          border: 'none',
          borderBottom: '1px solid #949494',
          margin: '0px',
          marginTop: '10px',
          fontSize: '1.4em',
          fontWeight: '200',
          height: '35px',
          width: '13%'
        }}
        inputFocusStyle={{
          borderColor: '#5ccaf4',
          borderBottom: `2px solid ${error ? '#5ccaf4' : '#f44336'}`
        }}
        type="numeric"
      />
    </div>
  );
};

PinCodeInput.propTypes = {
  error: PropTypes.object
};

const RenderPinField = ({
  input,
  meta,
  helperText,
  type,
  variant,
  multiline,
  id,
  rows,
  InputLabelProps
}) => {
  const displayError = !!(meta.submitFailed && meta.error);
  return (
    <TextField
      label=""
      id={id}
      fullWidth
      helperText={displayError ? meta.error : helperText}
      style={{ border: 'none' }}
      error={displayError}
      InputProps={{
        inputComponent: PinCodeInput,
        disableUnderline: true,
        'data-hj-whitelist': true
      }}
      InputLabelProps={InputLabelProps}
      multiline={multiline}
      rows={rows}
      variant={variant}
      type={type}
      {...input}
    />
  );
};

RenderPinField.propTypes = {
  helperText: PropTypes.string,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  variant: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  id: PropTypes.string,
  InputLabelProps: PropTypes.string
};

export default RenderPinField;
